// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"buildControls_BuildControls__3D4gX","OrderButton":"buildControls_OrderButton__2EsZL","enable":"buildControls_enable__2Dmdh"};